import axiosInstance from './axiosInstance'

const baseData = {
  handleData: async function (isForce, url, param) {
    let data = null
    let needLoad = false
    if (isForce) {
      needLoad = true
    } else {
      let str = sessionStorage.getItem("baseData-" + url)
      if (str == undefined || str == null || str == '') {
        needLoad = true
      } else {
        let mid = JSON.parse(str)
        if (mid instanceof Array) {
          console.log('handleArrayData mid', mid)
          if (mid.length > 0) {
            data = mid
          } else {
            needLoad = true
          }
        } else if (mid instanceof Object) {
          console.log('handleObjectData mid', mid)
          if (Object.keys(mid).length == 0) {
            needLoad = true
          } else {
            data = mid
          }
        } else {
          data = mid
        }
      }
    }
    if (needLoad) {
      await axiosInstance.post(url, param).then(res => {
        if (res.success) {
          data = res.result
          if (data) sessionStorage.setItem('baseData-' + url, JSON.stringify(data))
        } else {
          console.warn('load data with [' + url + '] error ', res.message)
        }
      }).catch((error) => {
        console.error('load data with [' + url + '] error ', error)
      })
    }
    return data
  }
}
export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$baseData', { value: baseData })
  }
}